<template>
  <div>
    <Toolbar4 />
    <SetPassword />
    <Footer4Entry />
  </div>
</template>

<script>
import Toolbar4 from '@/components/ui/landing/toolbar/Toolbar4.vue'
import SetPassword from '@/components/ui/setPassword/SetPassword.vue'
import Footer4Entry from '@/components/ui/landing/footer/Footer4Entry.vue'

export default {
  components: {
    Toolbar4,
    SetPassword,
    Footer4Entry

  }
}
</script>